import { useLocalizationContext } from 'shared/lib/localization';
import { NothingToDisplay } from 'shared/ui/nothing-to-display';

export const NoLegalDocument = () => {
    const {
        localizationService: { get },
    } = useLocalizationContext();

    return (
        <NothingToDisplay
            description={get('Licenses.NoLegalDocument.Description')}
            title={get('Licenses.NoLegalDocument.Header')}
            hideButton
        />
    );
};
